<template>
  <div>
    <v-select
      :value="value"
      dense
      solo
      flat
      outlined
      hide-details
      :items="items"
      item-text="client_name"
      item-value="uid"
      @input="onInput"
    >
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { STORE } from "@/constants";

export default {
  props: ["value"],

  data: () => ({
    items: [],
    loading: null,
  }),

  computed: {
    ...mapGetters({
      _rows: `${STORE.ADMIN.NAME}/${STORE.ADMIN.ROWS}`,
    }),
  },

  created() {
    this.getList();
  },

  methods: {
    async getList() {
      try {
        this.loading = true;
        await this.$store.dispatch(`${STORE.ADMIN.NAME}/${STORE.ADMIN.LIST}`, {
          objNm: "Client",
          page: 1,
          perpage: 100,
        });
        this.items = [
          {
            uid: null,
            client_name: "병원을 선택해주세요",
          },
          ...this._rows["Client"],
        ];
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    onInput(v) {
      this.$emit("input", v);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fields/Client.vue